import { useParams } from 'react-router-dom'
import { useAppointmentProductDetails } from '../hooks'
import { Card, Col, Descriptions, Result, Row, Table, Tag } from 'antd'
import { SuspenseSpin } from '@shared/styled/spin'
import { AppointmentProductMovement } from '../types'
import { green, red } from '@ant-design/colors'

export const AppointmentProductDetails = () => {
  const { id } = useParams<{ id: string }>()
  const { data, error, loading } = useAppointmentProductDetails(id)

  if (error) {
    return <Result status='500' title={error} />
  }

  if (loading) {
    return <SuspenseSpin />
  }

  if (!data) {
    return <Result status='404' title='Məlumat tapılmadı' />
  }

  return (
    <Row gutter={[12, 0]}>
      <Col xs={24} sm={12}>
        <Card bodyStyle={{ padding: 0 }} type='inner' size='small' title='Məhsul məlumatları'>
          <Descriptions size='small' column={1} bordered={true}>
            <Descriptions.Item label='Kod'>{data.product.id}</Descriptions.Item>
            <Descriptions.Item label='Ad'>{data.product.name}</Descriptions.Item>
            <Descriptions.Item label='Kateqoriya'>{data.product.category}</Descriptions.Item>
            <Descriptions.Item label='Qiymət'>{data.productPrice}</Descriptions.Item>
            <Descriptions.Item label='Maya dəyəri'>{data.costPrice}</Descriptions.Item>
            <Descriptions.Item label='Endirim'>{data.discount}</Descriptions.Item>
            <Descriptions.Item label='Yekun məbləğ'>{data.totalPrice}</Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col xs={24} sm={12}>
        <Card bodyStyle={{ padding: 0 }} type='inner' size='small' title='Personal və Tarix məlumatları'>
          <Descriptions size='small' column={1} bordered={true}>
            <Descriptions.Item label='Sərfiyyat ID'>{data.id}</Descriptions.Item>
            <Descriptions.Item label='Həkim'>{data.doctor.name}</Descriptions.Item>
            <Descriptions.Item label='Yaradan'>{data.createdBy.name}</Descriptions.Item>
            <Descriptions.Item label='Ziyarət ID'>{data.visitId}</Descriptions.Item>
            <Descriptions.Item label='Yaradılma tarixi'>{data.createdAt}</Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
      <Col xs={24}>
        <Card bodyStyle={{ padding: 0 }} type='inner' style={{ marginTop: 12 }} size='small' title='Stok hərəkətləri'>
          <Table pagination={{ hideOnSinglePage: true }} dataSource={data.stockMovements} rowKey='id' size='small' bordered={true}>
            <Table.Column dataIndex='id' title='Partiya' />
            <Table.Column dataIndex={['warehouse', 'name']} title='Anbar' />
            <Table.Column
              dataIndex='directionText'
              title='İstiqamət'
              render={(value, record: AppointmentProductMovement) => (
                <Tag color={record?.direction === 'in' ? green[3] : red[3]} style={{ color: '#000', fontSize: 14 }}>
                  {value}
                </Tag>
              )}
            />
            <Table.Column dataIndex='quantity' title='Miqdar' />
            <Table.Column dataIndex={['batch', 'supplier', 'name']} title='Təchizatçı' />
            <Table.Column dataIndex={['batch', 'expiryDate']} title='Son istifadə tarixi' />
            <Table.Column dataIndex='createdAt' title='Tarix' />
          </Table>
        </Card>
      </Col>
    </Row>
  )
}
